/* This file was GENERATED from the Webflow capture, which has since been
 * retired — see DESIGN-SYSTEM-PLAN.md. There is no generator any more: this is
 * now ordinary source, and editing it by hand is how you change it.
 * Frontmatter for every MDX document, for listing pages and SEO. The MDX files
 * themselves are the editable artefact; re-running the generator overwrites
 * them from the mirror, so edit MDX only once the mirror is retired.
 */

export interface DocMeta {
  slug: string
  route: string
  kind: 'post' | 'support'
  /** Visible heading. */
  title: string
  /** The original <title> tag — use this for <title>, not `title`. */
  seoTitle: string
  /**
   * How the support index links to this doc, when the live site labels it
   * differently from its own heading — "Wow Tags" in the list, "Wow Tags
   * Guide" at the top of the page. Absent means the two are the same.
   */
  indexTitle?: string
  description: string
  category: string | null
  author: string | null
  date: string | null
  heroImage: string | null
  /**
   * `false` keeps `heroImage` on /blog and related-post cards but leaves it
   * off the top of the post itself. Absent means the post shows it.
   */
  heroInPost?: boolean
  authorAvatar: string | null
  ogImage: string | null
  readingMinutes: number
  /**
   * Slugs for the post's Keep Reading cards, in order. Absent means
   * RelatedPosts picks by category, then most recent.
   */
  related?: string[]
}

export const ALL_DOCS: DocMeta[] = [
  {
    "slug": "5-months-of-building-singulate",
    "route": "/post/5-months-of-building-singulate",
    "kind": "post",
    "title": "Product update: 5 months building Singulate",
    "seoTitle": "Product update: 5 months building Singulate",
    "description": "Singulate in 5 months: we've launched AI tools, data automation, a nextgen email marketing platform, raised $2.3M and grew to 10, and built a beta with 50 partners seeing 3-7X average CTR gains. In 2025, we fly.",
    "category": "News",
    "author": "Dave Schools",
    "date": "2025-03-06",
    "heroImage": "/media/6798f5251248c62eca74026b_launching.jpg",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/6798f5251248c62eca74026b_launching.jpg",
    "readingMinutes": 1
  },
  {
    "slug": "ai-copywriters-replace-humans-best-thing-ever",
    "route": "/post/ai-copywriters-replace-humans-best-thing-ever",
    "kind": "post",
    "title": "Why AI Might Be The Best Thing That's Ever Happened To B2B Copywriters",
    "seoTitle": "Why AI Might Be The Best Thing That's Ever Happened To B2B Copywriters",
    "description": "Takeaways from a live session that introduces a practical framework for copywriters to use AI with data, including a live demo of Singulate’s unique personalization engine, and the launch of the Singulate Certified Copywriter Program.",
    "category": "Strategy",
    "author": "Singulate Team",
    "date": "2025-05-07",
    "heroImage": "/media/6818e69f913c324164e27751_Slide 16_9 - 3.png",
    "authorAvatar": "/media/6720e1c17049ec1a698ce066_Logo_Singulate.png",
    "ogImage": "/media/6818e69f913c324164e27751_Slide 16_9 - 3.png",
    "readingMinutes": 4
  },
  {
    "slug": "ai-personalization-mistakes",
    "route": "/post/ai-personalization-mistakes",
    "kind": "post",
    "title": "20 AI Personalization Malpractices",
    "seoTitle": "20 AI Personalization Malpractices",
    "description": "What B2B Marketers Need to Know About Using LLMs for Personalization at Scale in Email Marketing",
    "category": "Strategy",
    "author": "Dave Schools",
    "date": "2026-07-13",
    "heroImage": "/media/6a3d31f73524a1f4cc456040_Gemini_Generated_Image_fj90u0fj90u0fj90.png",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/6a3d31f73524a1f4cc456040_Gemini_Generated_Image_fj90u0fj90u0fj90.png",
    "readingMinutes": 12
  },
  {
    "slug": "ai-strategies-for-personalization-with-the-data-you-already-have",
    "route": "/post/ai-strategies-for-personalization-with-the-data-you-already-have",
    "kind": "post",
    "title": "AI Strategies for Personalization with the Data You Already Have",
    "seoTitle": "AI Strategies for Personalization with the Data You Already Have",
    "description": "Escape the Mail Merge Mindset. Use your existing data (e.g., industry, job title) to create more relevant messaging at scale. Say no to AI slop. Say hello to Adaptive Content.",
    "category": "Strategy",
    "author": "Dave Schools",
    "date": "2025-12-14",
    "heroImage": "/media/69123974b4253bad7eaa26c5_Frame 1000002472.png",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/69123974b4253bad7eaa26c5_Frame 1000002472.png",
    "readingMinutes": 9
  },
  {
    "slug": "announcing-singulate-outbound",
    "route": "/post/announcing-singulate-outbound",
    "kind": "post",
    "title": "Announcing Singulate Outbound",
    "seoTitle": "Announcing Singulate Outbound",
    "description": "Singulate is now for Sales. The future of GTM messaging is hyper-personalized. Use Singulate to power your marketing nurtures AND sales outreach. Tech agnostic, powered by real data + AI, delivered through Instantly and beyond.",
    "category": "Product",
    "author": "Dave Schools",
    "date": "2025-07-16",
    "heroImage": "/media/6876690c5017983d414495e5_soutbound-blog.png",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/6876690c5017983d414495e5_soutbound-blog.png",
    "readingMinutes": 3
  },
  {
    "slug": "chilipalooza-drive-spryng-conference-comparison",
    "route": "/post/chilipalooza-drive-spryng-conference-comparison",
    "kind": "post",
    "title": "I Attended Chilipalooza, Drive, and Spryng — Here's How They Compare",
    "seoTitle": "I Attended Chilipalooza, Drive, and Spryng — Here's How They Compare",
    "description": "Notes and observations from a random attendee about what it was like to be at all three and how each experience was different.",
    "category": "Strategy",
    "author": "Dave Schools",
    "date": "2025-04-02",
    "heroImage": "/media/67e5aaf5081781c7ca70b921_1400x700 (1).png",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/67e5aaf5081781c7ca70b921_1400x700 (1).png",
    "readingMinutes": 8
  },
  {
    "slug": "email-singulate-guide-with-examples",
    "route": "/post/email-singulate-guide-with-examples",
    "kind": "post",
    "title": "Writing an effective email with Singulate (Step-by-step guide with examples)",
    "seoTitle": "Writing an effective email with Singulate (Step-by-step guide with examples)",
    "description": "One email; multiple unique, hyper-targeted messages. Turn 25 emails into 1. Persona, vertical, and industry segmentation made easy.",
    "category": "Product",
    "author": "Dave Schools",
    "date": "2025-07-31",
    "heroImage": "/media/688a55a53554e5748242ccb4_how to write an effective email with singulate.png",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/688a55a53554e5748242ccb4_how to write an effective email with singulate.png",
    "readingMinutes": 11
  },
  {
    "slug": "end-of-year-update-2024",
    "route": "/post/end-of-year-update-2024",
    "kind": "post",
    "title": "End of Year Update 2024",
    "seoTitle": "End of Year Update 2024",
    "description": "What we've built, what we've learned, and what's ahead in 2025.",
    "category": "News",
    "author": "Dave Schools",
    "date": "2025-03-06",
    "heroImage": "/media/6798f4d31c3eca2ba8af8f94_founders.jpg",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/6798f4d31c3eca2ba8af8f94_founders.jpg",
    "readingMinutes": 4
  },
  {
    "slug": "end-of-year-update-2025",
    "route": "/post/end-of-year-update-2025",
    "kind": "post",
    "title": "End of Year Update 2025",
    "seoTitle": "End of Year Update 2025",
    "description": "A look back at what happened in 2025. Read about the challenges, highlights, and lessons we learned, and a preview of whats ahead in 2026.",
    "category": "News",
    "author": "Dave Schools",
    "date": "2026-01-30",
    "heroImage": "/media/694461025a91ced1895d8c53_Frame 1000002475.png",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/694461025a91ced1895d8c53_Frame 1000002475.png",
    "readingMinutes": 8
  },
  {
    "slug": "future-of-email-marketing",
    "route": "/post/future-of-email-marketing",
    "kind": "post",
    "title": "2025: AI and the Future of Email Marketing",
    "seoTitle": "2025: AI and the Future of Email Marketing",
    "description": "Explore the future of email marketing in 2025 with AI-driven personalization, advanced automation, and seamless tech stacks. Learn how generative AI is transforming the industry and discover the top 5 trends shaping the next wave of email marketing.",
    "category": "Strategy",
    "author": "Singulate Team",
    "date": "2025-03-06",
    "heroImage": "/media/678e93bbb1f4b48ae8e1a230_Article Cover Big (1400x700) (11).png",
    "authorAvatar": "/media/6720e1c17049ec1a698ce066_Logo_Singulate.png",
    "ogImage": "/media/678e93bbb1f4b48ae8e1a230_Article Cover Big (1400x700) (11).png",
    "readingMinutes": 5
  },
  {
    "slug": "generative-ai-marketing-email-vs-sales-email",
    "route": "/post/generative-ai-marketing-email-vs-sales-email",
    "kind": "post",
    "title": "Marketing Email Vs. Sales Email: 8 Key Differences",
    "seoTitle": "Marketing Email Vs. Sales Email: 8 Key Differences",
    "description": "Marketing and Sales BOTH use email, but HOW they use email is fundamentally different. You need both to power a successful business, but it's important to understand the 8 key differences.",
    "category": "Strategy",
    "author": "Dave Schools",
    "date": "2025-05-09",
    "heroImage": "/media/67bf773bea043234544e690e_genaimarsal.jpg",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/67bf773bea043234544e690e_genaimarsal.jpg",
    "readingMinutes": 1
  },
  {
    "slug": "generative-personalization",
    "route": "/post/generative-personalization",
    "kind": "post",
    "title": "How Generative Personalization is Revolutionizing Email Marketing",
    "seoTitle": "How Generative Personalization is Revolutionizing Email Marketing",
    "description": "Generative personalization can transform email marketing by creating highly tailored messages at scale. Unlike static personalization, marketers can us data and AI to craft unique content for each recipient, boosting engagement, click-through rates, and conversions.",
    "category": "Strategy",
    "author": "Singulate Team",
    "date": "2025-03-06",
    "heroImage": "/media/678e93473fcef6d059a41db8_Article Cover Big (1400x700) (10).png",
    "authorAvatar": "/media/6720e1c17049ec1a698ce066_Logo_Singulate.png",
    "ogImage": "/media/678e93473fcef6d059a41db8_Article Cover Big (1400x700) (10).png",
    "readingMinutes": 4
  },
  {
    "slug": "hiring-b2b-copywriters-freelance",
    "route": "/post/hiring-b2b-copywriters-freelance",
    "kind": "post",
    "title": "We’re Hiring: B2B Copywriters (Freelance)",
    "seoTitle": "We’re Hiring: B2B Copywriters (Freelance)",
    "description": "Join our community of AI-enabled copywriters and get paid to build high-converting email strategies using Singulate's advanced AI personalization platform. Get certified and trained. Learn new techniques for writing prompts, segmenting with data, and seeing what works. Apply now!",
    "category": "News",
    "author": "Singulate Team",
    "date": "2025-05-23",
    "heroImage": "/media/682d32efc8c47577afad9a38_1400x700 (3).png",
    "authorAvatar": "/media/6720e1c17049ec1a698ce066_Logo_Singulate.png",
    "ogImage": "/media/682d32efc8c47577afad9a38_1400x700 (3).png",
    "readingMinutes": 3
  },
  {
    "slug": "introducing-singulate",
    "route": "/post/introducing-singulate",
    "kind": "post",
    "title": "Introducing Singulate: Our Why",
    "seoTitle": "Introducing Singulate: Our Why",
    "description": "Out of stealth: Announcing our $2.3m pre-seed round, a team of 10, and an AI email marketing product (beta) that's solving the $60b personalization at scale problem",
    "category": "News",
    "author": "Singulate Team",
    "date": "2025-03-06",
    "heroImage": "/media/6798f5cbc45644c5cd7d904c_founders-couch.jpg",
    "authorAvatar": "/media/6720e1c17049ec1a698ce066_Logo_Singulate.png",
    "ogImage": "/media/6798f5cbc45644c5cd7d904c_founders-couch.jpg",
    "readingMinutes": 4
  },
  {
    "slug": "introducing-singulate-agent",
    "route": "/post/introducing-singulate-agent",
    "kind": "post",
    "title": "Introducing the Singulate Agent: From Brief to Campaign in 15 Minutes [Beta}",
    "seoTitle": "Introducing the Singulate Agent: From Brief to Campaign in 15 Minutes [Beta}",
    "description": "The Singulate Agent lets B2B marketers go from a plain-language brief to a fully built, segmented, personalized email campaign in minutes - saving the team hours and hours of copywriting, designing, and marketing operations work.",
    "category": "Product",
    "author": "Dave Schools",
    "date": "2026-08-04",
    "heroImage": "/media/6a71f82cf5119a59b36ef6e8_Singulate Agent Image.png",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/6a71f82cf5119a59b36ef6e8_Singulate Agent Image.png",
    "readingMinutes": 7
  },
  {
    "slug": "hubspot-nurture-agent-read-what-it-sends",
    "route": "/post/hubspot-nurture-agent-read-what-it-sends",
    "kind": "post",
    "title": "Turn on HubSpot's Nurture Agent. Then read what it sends.",
    "seoTitle": "Turn on HubSpot's Nurture Agent. Then read what it sends.",
    "description": "How to test HubSpot Nurture Agent on one nurture email, what to look for in the previews, what the test costs, and when to look beyond it.",
    "category": "Strategy",
    "author": "Chad Rosh",
    "date": "2026-11-03",
    "heroImage": "/media/hubspot-nurture-agent-read-what-it-sends.png",
    "authorAvatar": "/media/chad-rosh-avatar.jpg",
    "ogImage": "/media/hubspot-nurture-agent-read-what-it-sends.png",
    "readingMinutes": 4,
    "related": [
      "singulate-joins-hubspot-app-marketplace",
      "what-makes-a-message-land",
      "ai-strategies-for-personalization-with-the-data-you-already-have"
    ]
  },
  {
    "slug": "introducing-singulate-studio",
    "route": "/post/introducing-singulate-studio",
    "kind": "post",
    "title": "Introducing Singulate Studio: personalized email for people doing their own marketing",
    "seoTitle": "Introducing Singulate Studio: personalized email for people doing their own marketing",
    "description": "Singulate Studio is now live for consultants, coaches and agency owners. Add your website and your list, and Singulate writes an email that fits each person on it.",
    "category": "News",
    "author": "Chad Rosh",
    "date": "2026-10-20",
    "heroImage": "/media/introducing-singulate-studio.png",
    "authorAvatar": "/media/chad-rosh-avatar.jpg",
    "ogImage": "/media/introducing-singulate-studio.png",
    "readingMinutes": 3,
    "related": [
      "what-makes-a-message-land",
      "singulate-best-prompts-and-practices",
      "ai-strategies-for-personalization-with-the-data-you-already-have"
    ]
  },
  {
    "slug": "llms-broke-personalization-modular-ai-fixes-it",
    "route": "/post/llms-broke-personalization-modular-ai-fixes-it",
    "kind": "post",
    "title": "LLMs Broke Personalization. Modular AI Fixes It.",
    "seoTitle": "LLMs Broke Personalization. Modular AI Fixes It.",
    "description": "LLMs promised effortless personalization and delivered mail merge with better adjectives. Here is why unconstrained AI generation loses control of strategy, and why the fix is not less AI, but a modular architecture built from approved building blocks.",
    "category": "Product",
    "author": "Singulate Team",
    "date": "2026-09-06",
    "heroImage": "/media/llms-broke-personalization-modular-ai-fixes-it.webp",
    "authorAvatar": "/media/6720e1c17049ec1a698ce066_Logo_Singulate.png",
    "ogImage": "/media/llms-broke-personalization-modular-ai-fixes-it.webp",
    "readingMinutes": 2
  },
  {
    "slug": "llms-broke-personalization-we-fixed-it",
    "route": "/post/llms-broke-personalization-we-fixed-it",
    "kind": "post",
    "title": "LLMs Broke Personalization. We Fixed It",
    "seoTitle": "LLMs Broke Personalization. We Fixed It",
    "description": "Nico shares his journey from Hopin to 11x to cofounding Singulate and the insights from his deep experience in LLM technology that developed into the key innovation behind Singulate and the future of marketing personalization.",
    "category": "Product",
    "author": "Nico Klein",
    "date": "2026-01-21",
    "heroImage": "/media/6967eb3431cc62feb3748def_1400x700 (8).png",
    "authorAvatar": "/media/6967e90273be227c59ca6560_High_Res_Singulate_selects-3973.jpg",
    "ogImage": "/media/6967eb3431cc62feb3748def_1400x700 (8).png",
    "readingMinutes": 6
  },
  {
    "slug": "marketo-integration-personalization-segmentation",
    "route": "/post/marketo-integration-personalization-segmentation",
    "kind": "post",
    "title": "Marketo: How to Use AI for Reliable 1:1 Personalization at Scale",
    "seoTitle": "Marketo: How to Use AI for Reliable 1:1 Personalization at Scale",
    "description": "How Singulate's campaign builder works with Marketo to enable an AI-native UI for personalized segmentation and orchestration.",
    "category": "Product",
    "author": "Singulate Team",
    "date": "2026-04-21",
    "heroImage": "/media/697686e0cc7ceafc546c34db_Frame 1000002479 (1).png",
    "authorAvatar": "/media/6720e1c17049ec1a698ce066_Logo_Singulate.png",
    "ogImage": "/media/697686e0cc7ceafc546c34db_Frame 1000002479 (1).png",
    "readingMinutes": 5
  },
  {
    "slug": "our-best-month-ever",
    "route": "/post/our-best-month-ever",
    "kind": "post",
    "title": "Our Best Month Ever",
    "seoTitle": "Our Best Month Ever",
    "description": "The latest on the Singulate journey.",
    "category": "News",
    "author": "Dave Schools",
    "date": "2025-10-07",
    "heroImage": "/media/68de7b6310b3fea2c09a819b_bestmonth.png",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/68de7b6310b3fea2c09a819b_bestmonth.png",
    "readingMinutes": 3
  },
  {
    "slug": "singulate-best-prompts-and-practices",
    "route": "/post/singulate-best-prompts-and-practices",
    "kind": "post",
    "title": "Singulate Best Prompts and Practices",
    "seoTitle": "Singulate Best Prompts and Practices",
    "description": "A practical guide to getting the most out of Singulate: start with the Agent, cap your word counts, make the first five words count, and combine Wow Tags, Branched Content, and Snippets so no contact ever gets a \"blast\" email.",
    "category": "Product",
    "author": "Dave Schools",
    "date": "2026-08-28",
    "heroImage": "/media/6a91afbb58823a4866f0cd21_Frame 1948759839.png",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/6a91afbb58823a4866f0cd21_Frame 1948759839.png",
    "readingMinutes": 7
  },
  {
    "slug": "singulate-email-marketing-ai-pre-seed-round",
    "route": "/post/singulate-email-marketing-ai-pre-seed-round",
    "kind": "post",
    "title": "Singulate raises $2.3 million pre-seed to transform email marketing industry with AI",
    "seoTitle": "Singulate raises $2.3 million pre-seed to transform email marketing industry with AI",
    "description": "Early Hopin team announces new AI company that is using generative personalization and LLM workflows to rebuild email marketing for B2B companies",
    "category": "News",
    "author": "Singulate Team",
    "date": "2025-03-06",
    "heroImage": "/media/6798f651ffe15017aafe093c_singulate-logo.jpg",
    "authorAvatar": "/media/6720e1c17049ec1a698ce066_Logo_Singulate.png",
    "ogImage": "/media/6798f651ffe15017aafe093c_singulate-logo.jpg",
    "readingMinutes": 2
  },
  {
    "slug": "singulate-faqs-waitlist",
    "route": "/post/singulate-faqs-waitlist",
    "kind": "post",
    "title": "1,000 people on our waitlist and other updates",
    "seoTitle": "1,000 people on our waitlist and other updates",
    "description": "A couple weeks out of stealth, Singulate surpasses 1,000 waitlist users, debuts at SaaStock and signs GTM advisors. Read thoughts on the future of AI cold outreach vs. AI marketing and some FAQs about what we're building.",
    "category": "News",
    "author": "Dave Schools",
    "date": "2025-03-06",
    "heroImage": "/media/6798f57cb443fe7ba5bd9e8e_waitlist.jpg",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/6798f57cb443fe7ba5bd9e8e_waitlist.jpg",
    "readingMinutes": 5
  },
  {
    "slug": "singulate-joins-hubspot-app-marketplace",
    "route": "/post/singulate-joins-hubspot-app-marketplace",
    "kind": "post",
    "title": "Singulate Joins Hubspot App Marketplace",
    "seoTitle": "Singulate Joins Hubspot App Marketplace",
    "description": "Augment HubSpot with nextgen AI features, including instant segmentation, AI data clean up, and generative personalization.",
    "category": "Product",
    "author": "Dave Schools",
    "date": "2025-04-10",
    "heroImage": "/media/67f7bba4d3ebf5c4230805f8_Article Cover Big (1400x700) (5).png",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/67f7bba4d3ebf5c4230805f8_Article Cover Big (1400x700) (5).png",
    "readingMinutes": 4
  },
  {
    "slug": "singulate-methodology",
    "route": "/post/singulate-methodology",
    "kind": "post",
    "title": "Singulate Methodology",
    "seoTitle": "Singulate Methodology",
    "description": "How to use data to write better personalized messaging. A deep dive into modular thinking and AI techniques with data to create more relevant content that scales reliably.",
    "category": "Product",
    "author": "Dave Schools",
    "date": "2026-04-01",
    "heroImage": "/media/6964f589a0c92b31627f2df0_Option 1.png",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/6964f589a0c92b31627f2df0_Option 1.png",
    "readingMinutes": 21
  },
  {
    "slug": "singulate-research-clay-for-marketing",
    "route": "/post/singulate-research-clay-for-marketing",
    "kind": "post",
    "title": "Announcing Singulate Research",
    "seoTitle": "Announcing Singulate Research",
    "description": "Say goodbye to missing data. Introducing real-time enrichment generated at the time of send. Experience 1:1 agentic personalization at scale.",
    "category": "Product",
    "author": "Dave Schools",
    "date": "2025-09-24",
    "heroImage": "/media/68c3617a0dc4c2692bac4894_Frame 1000002469.png",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/68c3617a0dc4c2692bac4894_Frame 1000002469.png",
    "readingMinutes": 5
  },
  {
    "slug": "singulate-sandbox",
    "route": "/post/singulate-sandbox",
    "kind": "post",
    "title": "Announcing Singulate Sandbox",
    "seoTitle": "Announcing Singulate Sandbox",
    "description": "Experience Singulate with zero setup required. Walk through a self-guided product tutorial to learn how Singulate's AI features work. And other exciting updates.",
    "category": "Product",
    "author": "Dave Schools",
    "date": "2025-08-05",
    "heroImage": "/media/6892816f6bf07ffc2128652d_Frame 7 (3).png",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/6892816f6bf07ffc2128652d_Frame 7 (3).png",
    "readingMinutes": 2
  },
  {
    "slug": "the-ultimate-email-copywriter-tool-yes-it-uses-ai-but-not-like-you-think",
    "route": "/post/the-ultimate-email-copywriter-tool-yes-it-uses-ai-but-not-like-you-think",
    "kind": "post",
    "title": "The Ultimate Email Copywriter Tool: Yes, It Uses AI, But Not Like You Think",
    "seoTitle": "The Ultimate Email Copywriter Tool: Yes, It Uses AI, But Not Like You Think",
    "description": "\"The conversion copywriter's dream tool.\" Come see what's possible when you take the pain out of segmentation and personalization at scale.",
    "category": "Product",
    "author": "Singulate Team",
    "date": "2025-03-06",
    "heroImage": "/media/678e930f2d16560129e64498_Article Cover Big (1400x700) (9).png",
    "authorAvatar": "/media/6720e1c17049ec1a698ce066_Logo_Singulate.png",
    "ogImage": "/media/678e930f2d16560129e64498_Article Cover Big (1400x700) (9).png",
    "readingMinutes": 4
  },
  {
    "slug": "unlimited-micro-segmentation-why-it-matters-and-how-to-create",
    "route": "/post/unlimited-micro-segmentation-why-it-matters-and-how-to-create",
    "kind": "post",
    "title": "Unlimited Micro-Segmentation: Marketing Ops Heaven",
    "seoTitle": "Unlimited Micro-Segmentation: Marketing Ops Heaven",
    "description": "Generative AI makes micro-segmentation unbelievably easy. Email marketers have all-new possibilities to deliver highly personalized messages at scale. Singulate simplifies segmentation using generative AI, saving copywriters time and increasing efficiency by 90%. The result is 6x higher engagement rates.",
    "category": "Product",
    "author": "Singulate Team",
    "date": "2025-03-06",
    "heroImage": "/media/679a60feac34245781716cbd_1400x700 (1).png",
    "authorAvatar": "/media/6720e1c17049ec1a698ce066_Logo_Singulate.png",
    "ogImage": "/media/679a60feac34245781716cbd_1400x700 (1).png",
    "readingMinutes": 4
  },
  {
    "slug": "what-emails-perform-best-the-data-doesnt-lie",
    "route": "/post/what-emails-perform-best-the-data-doesnt-lie",
    "kind": "post",
    "title": "What Emails Perform Best? The Data Doesn't Lie",
    "seoTitle": "What Emails Perform Best? The Data Doesn't Lie",
    "description": "Brand vs. Person, Plaintext vs. HTML: data-backed answers for better emails",
    "category": "Strategy",
    "author": "Dave Schools",
    "date": "2025-05-09",
    "heroImage": "/media/681dfd42a60e3d5779cb8688_1400x700 (5).png",
    "authorAvatar": "/media/67238be3ae0cf632b17da914_High_Res_Singulate_selects-3700 (2).jpg",
    "ogImage": "/media/681dfd42a60e3d5779cb8688_1400x700 (5).png",
    "readingMinutes": 3
  },
  {
    "slug": "what-makes-a-message-land",
    "route": "/post/what-makes-a-message-land",
    "kind": "post",
    "title": "I analyzed 4,500 posts from LinkedIn's Top Voices. Here's what makes a message land.",
    "seoTitle": "I analyzed 4,500 posts from LinkedIn's Top Voices. Here's what makes a message land.",
    "description": "What 93 of LinkedIn's newest Top Voices taught me about getting people to stop, care, and actually pay attention.",
    "category": "Strategy",
    "author": "Chad Rosh",
    "date": "2026-10-01",
    "heroImage": "/media/what-makes-a-message-land.webp",
    "heroInPost": false,
    "authorAvatar": "/media/chad-rosh-avatar.jpg",
    "ogImage": "/media/what-makes-a-message-land.webp",
    "readingMinutes": 5
  },
  {
    "slug": "why-we-built-the-worlds-first-marketing-personalization-api",
    "route": "/post/why-we-built-the-worlds-first-marketing-personalization-api",
    "kind": "post",
    "title": "Why We Built the World’s First Messaging Personalization API",
    "seoTitle": "Why We Built the World’s First Messaging Personalization API",
    "description": "Singulate's Messaging Personalization API brings our Modular Communication Strategy Architecture to any developer, delivering higher-quality, more reliable personalized messaging at up to 90% lower token cost than traditional LLM approaches.",
    "category": "Product",
    "author": "Nico Klein",
    "date": "2026-04-21",
    "heroImage": "/media/69e0e54ca34dedd82f9df413_Prompt engineering.png",
    "authorAvatar": "/media/6967e90273be227c59ca6560_High_Res_Singulate_selects-3973.jpg",
    "ogImage": "/media/69e0e54ca34dedd82f9df413_Prompt engineering.png",
    "readingMinutes": 4
  },
  {
    "slug": "copywriting/strategies",
    "route": "/support/copywriting/strategies",
    "kind": "support",
    "title": "Copywriting Strategies",
    "seoTitle": "Strategies",
    "description": "Use ChatGPT alongside Singulate to add deeper personalization and segmentation to your email marketing, with prompts and step-by-step strategies.",
    "category": "copywriting",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 4,
    "indexTitle": "Strategies"
  },
  {
    "slug": "hubspot-integration/create-a-b-split-tests",
    "route": "/support/hubspot-integration/create-a-b-split-tests",
    "kind": "support",
    "title": "Create A/B Split Tests",
    "seoTitle": "Create A/B Split Tests",
    "description": "Set up an A/B split test in HubSpot to measure your singulated email against non-personalized base messaging, and read the results.",
    "category": "hubspot-integration",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 2
  },
  {
    "slug": "hubspot-integration/create-synchronized-contact-list",
    "route": "/support/hubspot-integration/create-synchronized-contact-list",
    "kind": "support",
    "title": "Create Synchronized Contact List",
    "seoTitle": "Create Synchronized Contact List",
    "description": "Create a Contact List in Singulate and sync it with HubSpot so your audience data stays current across both platforms.",
    "category": "hubspot-integration",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 1
  },
  {
    "slug": "hubspot-integration/duplicate-a-workflow",
    "route": "/support/hubspot-integration/duplicate-a-workflow",
    "kind": "support",
    "title": "Duplicate a Workflow",
    "seoTitle": "Duplicate a Workflow",
    "description": "Duplicate a HubSpot workflow for use with Singulate: which steps to remove, what to rename, and how to avoid breaking live campaigns.",
    "category": "hubspot-integration",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 1
  },
  {
    "slug": "hubspot-integration/integrate-hubspot-account",
    "route": "/support/hubspot-integration/integrate-hubspot-account",
    "kind": "support",
    "title": "Integrate your HubSpot Account",
    "seoTitle": "Overview",
    "description": "Link your HubSpot account to Singulate to sync contacts and send personalized email. Works best on HubSpot Professional and Enterprise plans.",
    "category": "hubspot-integration",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 2,
    "indexTitle": "Integrate Your HubSpot Account"
  },
  {
    "slug": "hubspot-integration/publish-a-workflow",
    "route": "/support/hubspot-integration/publish-a-workflow",
    "kind": "support",
    "title": "Publish a Workflow",
    "seoTitle": "Publish a Workflow",
    "description": "Build an automated HubSpot workflow with a Send with Singulate step, then publish it to deliver personalized email at scale.",
    "category": "hubspot-integration",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 5
  },
  {
    "slug": "hubspot-integration/send-a-one-off-email",
    "route": "/support/hubspot-integration/send-a-one-off-email",
    "kind": "support",
    "title": "Send a One-Off Email",
    "seoTitle": "Send a One-Off email",
    "description": "Create a Singulate campaign, choose your audience and template, and send a one-off personalized email through HubSpot.",
    "category": "hubspot-integration",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 3
  },
  {
    "slug": "hubspot-integration/signatures-subject-lines-and-senders",
    "route": "/support/hubspot-integration/signatures-subject-lines-and-senders",
    "kind": "support",
    "title": "Signatures, Subject Lines and Senders",
    "seoTitle": "Signatures, Subject Lines and Senders",
    "description": "Configure signatures, subject lines, and senders for Singulate emails and HubSpot automations, and what editing in HubSpot changes.",
    "category": "hubspot-integration",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 2,
    "indexTitle": "Signature, Subject Lines and Senders"
  },
  {
    "slug": "hubspot-integration/understanding-your-attributes",
    "route": "/support/hubspot-integration/understanding-your-attributes",
    "kind": "support",
    "title": "Understanding Your Attributes",
    "seoTitle": "Understanding Your Attributes",
    "description": "Core, custom, and computed properties in Singulate: how each type works and how to map your HubSpot attributes for personalization.",
    "category": "hubspot-integration",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 2
  },
  {
    "slug": "instantly-integration/integrate-your-instantly-account",
    "route": "/support/instantly-integration/integrate-your-instantly-account",
    "kind": "support",
    "title": "Integrate Your Instantly Account",
    "seoTitle": "Integrate Your Instantly Account",
    "description": "Connect Instantly to Singulate so you can send hyper-personalized cold outreach directly from your Instantly account.",
    "category": "instantly-integration",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 1
  },
  {
    "slug": "instantly-integration/send-singulate-emails-with-instantly",
    "route": "/support/instantly-integration/send-singulate-emails-with-instantly",
    "kind": "support",
    "title": "Send Singulate Emails with Instantly",
    "seoTitle": "Send Singulate Emails with Instantly",
    "description": "Create a Singulate campaign and send it as a one-off hyper-personalized cold email through Instantly, step by step.",
    "category": "instantly-integration",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 2,
    "indexTitle": "Send Singulate Emails via Instantly"
  },
  {
    "slug": "product/branched-content",
    "route": "/support/product/branched-content",
    "kind": "support",
    "title": "Branched Content Guide",
    "seoTitle": "Branched Content",
    "description": "Create unlimited audience segments on the fly with AI, verify the segment data, and write separate content for each branch of your email.",
    "category": "product",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 3,
    "indexTitle": "Branched Content"
  },
  {
    "slug": "product/content-assets",
    "route": "/support/product/content-assets",
    "kind": "support",
    "title": "Content Assets",
    "seoTitle": "Content Assets",
    "description": "Save and re-use your best Singulated Snippets, branched content, and sections across any email or template to repurpose winning content.",
    "category": "product",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 2,
    "indexTitle": "Repeatable Content Assets"
  },
  {
    "slug": "product/editor",
    "route": "/support/product/editor",
    "kind": "support",
    "title": "Editor",
    "seoTitle": "Editor",
    "description": "The Singulate editor: Global Styles for on-brand emails, sections and CTAs, plus Wow Tags, Branched Paragraphs, and Singulated Snippets.",
    "category": "product",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 1
  },
  {
    "slug": "product/get-started",
    "route": "/support/product/get-started",
    "kind": "support",
    "title": "Getting Started with Singulate",
    "seoTitle": "Get Started",
    "description": "Set up your Singulate account: organization settings, sending details, and the first steps to launching a personalized campaign.",
    "category": "product",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 2
  },
  {
    "slug": "product/previewing-and-testing-your-singulate-campaigns",
    "route": "/support/product/previewing-and-testing-your-singulate-campaigns",
    "kind": "support",
    "title": "Previewing and Testing Your Singulate Campaigns",
    "seoTitle": "Previewing and Testing Your Singulate Campaigns",
    "description": "Preview and quality-check your Singulate campaigns and automations before they send, including personalized and fallback content.",
    "category": "product",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 2
  },
  {
    "slug": "product/set-up-singulate-as-your-esp-sending-with-singulate",
    "route": "/support/product/set-up-singulate-as-your-esp-sending-with-singulate",
    "kind": "support",
    "title": "Set up Singulate as Your ESP (Sending with Singulate)",
    "seoTitle": "Set up Singulate as Your ESP (Sending with Singulate)",
    "description": "Use Singulate as your ESP. Configure DNS for your sending domain and start delivering personalized email directly from Singulate.",
    "category": "product",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 1
  },
  {
    "slug": "product/singulate-analytics",
    "route": "/support/product/singulate-analytics",
    "kind": "support",
    "title": "Singulate Analytics",
    "seoTitle": "Singulate Analytics",
    "description": "Personalization analytics that reveal engagement by segment and compare personalized against fallback content, so you can optimize campaigns.",
    "category": "product",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 1
  },
  {
    "slug": "product/singulated-snippets",
    "route": "/support/product/singulated-snippets",
    "kind": "support",
    "title": "Singulated Snippets Guide",
    "seoTitle": "Singulated Snippets",
    "description": "Singulated Snippets let you write for the individual at scale, combining multiple data points into perfectly-worded, fine-tuned statements.",
    "category": "product",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 4,
    "indexTitle": "Singulated Snippets"
  },
  {
    "slug": "product/wow-tags",
    "route": "/support/product/wow-tags",
    "kind": "support",
    "title": "Wow Tags Guide",
    "seoTitle": "Wow Tags",
    "description": "Wow Tags is Singulate's LLM-powered data cleanup feature. What it does well today, its current limits, and how to use it in your messaging.",
    "category": "product",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 2,
    "indexTitle": "Wow Tags"
  },
  {
    "slug": "resources/project-brief",
    "route": "/support/resources/project-brief",
    "kind": "support",
    "title": "Project Brief",
    "seoTitle": "Project Brief",
    "description": "Copy our Google Doc template to plan your Singulate email project, from audience and data through messaging and launch.",
    "category": "resources",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 1
  },
  {
    "slug": "resources/recommended-data",
    "route": "/support/resources/recommended-data",
    "kind": "support",
    "title": "Recommended Data",
    "seoTitle": "Recommended Data",
    "description": "Which contact data to import into Singulate — unstructured open-form text, call notes and chat transcripts are the most valuable for segmentation and personalization.",
    "category": "resources",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 1
  },
  {
    "slug": "resources/swipe-files",
    "route": "/support/resources/swipe-files",
    "kind": "support",
    "title": "Swipe Files",
    "seoTitle": "Swipe Files",
    "description": "Ready-to-use Wow Tag and Singulated Snippet prompts you can copy straight into Singulate, including company name cleanup and normalization.",
    "category": "resources",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 9
  },
  {
    "slug": "zapier-integration/integrate-your-zapier-with-singulate",
    "route": "/support/zapier-integration/integrate-your-zapier-with-singulate",
    "kind": "support",
    "title": "Integrate Your Zapier with Singulate",
    "seoTitle": "Integrate Your Zapier with Singulate",
    "description": "Connect Zapier to Singulate and create your first Zap to send hyper-personalized Gmail campaigns.",
    "category": "zapier-integration",
    "author": null,
    "date": null,
    "heroImage": null,
    "authorAvatar": null,
    "ogImage": null,
    "readingMinutes": 2,
    "indexTitle": "Integrate Your Zapier Account"
  }
]

export const POSTS: DocMeta[] = ALL_DOCS.filter((d) => d.kind === 'post').sort((a, b) =>
  (b.date ?? '').localeCompare(a.date ?? ''),
)

export const SUPPORT_DOCS: DocMeta[] = ALL_DOCS.filter((d) => d.kind === 'support')

export const POST_CATEGORIES = [
  ...new Set(POSTS.map((p) => p.category).filter(Boolean)),
] as string[]
export const SUPPORT_GROUPS = [
  ...new Set(SUPPORT_DOCS.map((d) => d.category).filter(Boolean)),
] as string[]
